import React, { useState, useEffect } from 'react';
import useReduxState from 'src/hooks/useReduxState';
import System from 'src/helper/system';
import Helper from 'src/helper/Helper';
import { profileStore } from 'src/hooks/profile';
import Constants from 'src/helper/Constants';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";

const ProfileAddressPopup = (props) => {
  const { companyNamePattern, addressPattern, countryCodes, addressType, siteUser, zipCodePattern, shippingAddressType:{Type: { DOMESTIC }} } = Constants;
  const { SetStatus, data } = props;
  const [detailValidation, setDetailValidation] = useState({});
  const [stateList, setStateList] = useState([]);
  const [countryName, setCountryName] = useState("");
  let [stateName, setStateName] = useState("");
  const [{ countryList }, { get_profile_account_information, get_country_list, get_state_list }, { add_profile_address, edit_profile_invoice_address, validate_profile_address }] = profileStore();
  const [, setNewShipTo] = useReduxState('', "setNewShipTo");
  const [, setTnc] = useReduxState(false, 'setTnc');
  const isWebUser = System.avUserInfoData.currentUser === siteUser.WEB
  const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();
  const messages = {
    'addInvoice': '<b>Your Invoice Address</b> has been Added successfully.',
    'editInvoice': '<b>Your Invoice Address</b> has been updated successfully.',
    'addShipping': '<b>Shipping Address</b> has been added successfully.',
    //'editShipping': 'Your shipping address has been updated successfully'
    'coreuser': 'Your request has been successfuslly submitted. New Shipping Address cannot be used and appear as a Shipping Address selection until it is verified.'
  };
  const [invoiceDetail, setInvoiceDetail] = useState({ addressType: data.type });
  const [__check] = useAxiosIndicatorCheck();
  const loader = __check(['ADD_PROFILE_ADDRESS_API_CALL', 'VALIDATE_ADDRESS_API_CALL']).status;

  useEffect(() => {
    async function fetchHere() {
      await get_country_list();
    }
    if (countryList?.length <= 0) {
      fetchHere()
    }
  }, [])

  useEffect(() => {
    if (Object.keys(data.addressInfo).length > 0) {
      if ((Helper.valueIsNotNull(data.addressInfo.address)) && (Helper.valueIsNotNull(data.addressInfo.address.countryCode))) {
        async function fetchStateList() {
          if (countryCodes.includes(data.addressInfo.address.countryCode)) {
            setStateList(await get_state_list(data.addressInfo.address.countryCode))
          }
        }
        fetchStateList()
      }
      setCountryName(data.addressInfo.address.countryName);
      setStateName(data.addressInfo.address.stateName)
      setInvoiceDetail({ ...data.addressInfo.address, id: data.addressInfo.id, companyName: data.addressInfo.companyName, addressType: data.type })
    }
  }, [data.addressInfo])

  const onValueChange = (field, value) => {
    if (detailValidation && Object.keys(detailValidation).length > 0) {
      delete detailValidation[field];
    }
    setInvoiceDetail({ ...invoiceDetail, [field]: value, countryName: countryName, stateName: stateName });
  };

  const saveAddress = async (addInfo) => {
    const res = await add_profile_address(addInfo);
    if (res.isSuccessFull) {
      setNewShipTo(res.data);
      SetStatus(false);
      if (isWebUser) get_profile_account_information();

      const successMessage = data.type === addressType.SHIP_TO
        ? (isWebUser ? messages['addShipping'] : messages['coreuser'])
        : messages['addInvoice'];
  
      system_alert_indicator({
        name: 'profile',
        message: successMessage,
        type: "success"
      });
    }
  };
  
  const showAddressValidationPopup = async (req, isAddressInfoEmpty, suggestedAddress = [], id = '') => {
    System.popup('VerifyAddressPopup', {
      suggestedAddress: suggestedAddress.map((r) => ({
        ...r,
        company: invoiceDetail?.companyName,
        addressType: data.type,
                id,
        isAddressInfoEmpty
      })),
      enteredAddress: {
        ...req,
        company: invoiceDetail?.companyName,
        countryName: invoiceDetail?.countryName,
        stateName: invoiceDetail?.stateName,
        addressType: data.type,
        id,
        isAddressInfoEmpty
      }
    });
  };
  
  const processAddressValidation = async (req, isAddressInfoEmpty, id = '') => {
    const res = await validate_profile_address(req);
    if (Helper.valueIsNotNull(res) || (res?.length > 0)) {
      await showAddressValidationPopup(req, isAddressInfoEmpty, res, id);
      return false; // Prevent further processing if validation fails
    }
    return true; // Proceed if no validation issues
  };
  
  const onSaveUser = async () => {
    if (!onValidateData()) return;
    const isAddressInfoEmpty = Object.keys(data.addressInfo).length === 0;
    const req = {
      address1: invoiceDetail?.addressLineOne,
      address2: invoiceDetail?.addressLineTwo,
      city: invoiceDetail?.cityName,
      stateCode: invoiceDetail?.stateCode,
      postalCode: invoiceDetail?.postalCode,
      countryCode: invoiceDetail?.countryCode
    };
    const addressType=System.getAddressTypeFromCountryCode(invoiceDetail?.countryCode)
    // If address information is empty and either SHIP_TO or BILL_TO, validate address
    if (isAddressInfoEmpty) {
      if(addressType === DOMESTIC){
        const isResponseEmpty = await processAddressValidation(req, isAddressInfoEmpty);
        if (isResponseEmpty){
          await saveAddress(invoiceDetail);
        }
      } else {
        await saveAddress(invoiceDetail);
      }  
    } else {
      // For existing address, handle regular save or edit
      if(addressType === DOMESTIC){
        const isResponseEmpty = await processAddressValidation(req, isAddressInfoEmpty, invoiceDetail?.id);
        if (isResponseEmpty){
          saveEditAddress(invoiceDetail)
        }
      } else {
        saveEditAddress(invoiceDetail)
      }
    }
  
    Helper.scrollTop();
  };

  const saveEditAddress = async (addInfo) => {
    const resp = await edit_profile_invoice_address(addInfo);
    if (resp.isSuccessFull) {
      await get_profile_account_information();
      SetStatus(false);
      setTnc(false)
      system_alert_indicator({
        name: 'profile',
        message: messages['editInvoice'],
        type: "success"
      });
    }
  };

  const onValidateData = () => {
    let validationModal = {};
    let isCountryCode = (Helper.valueIsNotNull(invoiceDetail.countryCode));
    if ((!Helper.valueIsNotNull(invoiceDetail.companyName)) || (!Helper.validateRegex(invoiceDetail.companyName, companyNamePattern)) || (invoiceDetail.companyName.length > 100)) {
      validationModal.companyName = "A valid company name is required.";
    }
    if ((!Helper.valueIsNotNull(invoiceDetail.postalCode)) || (!(Helper.validateRegex(invoiceDetail.postalCode, zipCodePattern))) || (invoiceDetail.postalCode.length > 40)) {
      validationModal.postalCode = "A valid zip code is required.";
    }
    if (isCountryCode && countryCodes.includes(invoiceDetail.countryCode) && !Helper.valueIsNotNull(invoiceDetail.stateCode)) {
      validationModal.stateCode = "A valid State/Province is required.";
    }
    if ((!Helper.valueIsNotNull(invoiceDetail.addressLineOne)) || (!Helper.validateRegex(invoiceDetail.addressLineOne, addressPattern))) {
      validationModal.addressLineOne = "A valid address is required.";
    }
    if ((Helper.valueIsNotNull(invoiceDetail.addressLineTwo)) && ((!Helper.validateRegex(invoiceDetail.addressLineTwo, addressPattern)))) {
      validationModal.addressLineTwo = "A valid address is required.";
    }
    if ((!Helper.valueIsNotNull(invoiceDetail.cityName)) || (!Helper.validateRegex(invoiceDetail.cityName, addressPattern))) {
      validationModal.cityName = "A valid city is required.";
    }
    if (!isCountryCode) {
      validationModal.countryCode = "A valid country is required.";
    }
    setDetailValidation(validationModal);
    return Object.keys(validationModal).length === 0;
  };

  const renderStateListOnCountryChange = async (value) => {
    setStateList(await get_state_list(value))
  }

  return (
    <div className="avnet-modal modal-730">
      <div className="avnet-modal-inner">
        <button type="button" className="close" disabled={loader} data-dismiss="modal" onClick={() => { SetStatus(false) }}>×</button>
        <div className="modal-header justify-content-center">
          <h1 className="pcn-modal-heading"> {data?.type === addressType.BILL_TO ? (Object.keys(data.addressInfo).length === 0 ? 'Add Invoice Address' : 'Edit Invoice Address') : isWebUser ? 'Add Shipping Address' : 'Request Shipping Address'}</h1>
        </div>
        <div className="modal-body">
          <form>
            <div className="col-12">
              <div className="form-group">
                <label htmlFor="companyName" className="d-block">Company Name*</label>
                <input
                  type="text"
                  className={`form-control form-control-sm ${detailValidation.companyName ? "error" : ""}`}
                  id="companyName"
                  placeholder="Company Name"
                  name="companyName"
                  value={invoiceDetail.companyName}
                  onChange={({ target: { value } }) => onValueChange("companyName", value)}
                  maxLength={35}
                />
                {detailValidation.companyName && <p className="error">{detailValidation.companyName}</p>}
              </div>
            </div>

            <div className="col-12">
              <div className="form-group">
                <label htmlFor="addressLineOne" className="d-block">Address 1*</label>
                <input
                  type="text"
                  className={`form-control form-control-sm ${detailValidation.addressLineOne ? "error" : ""}`}
                  id="addressLineOne"
                  placeholder="Address 1"
                  name="addressLineOne"
                  maxLength={35}
                  value={invoiceDetail.addressLineOne}
                  onChange={({ target: { value } }) => onValueChange("addressLineOne", value)}
                />
                
                {detailValidation.addressLineOne && <p className="error">{detailValidation.addressLineOne}</p>}
              </div>
            </div>

            <div className="col-12">
              <div className="form-group">
                <label htmlFor="addressLineTwo" className="d-block">Address 2</label>
                <input
                  type="text"
                  className={`form-control form-control-sm ${detailValidation.addressLineTwo ? "error" : ""}`}
                  id="addressLineTwo"
                  placeholder="Address 2"
                  name="addressLineTwo"
                  maxLength={35}
                  value={invoiceDetail.addressLineTwo}
                  onChange={({ target: { value } }) => onValueChange("addressLineTwo", value)}
                />
                {detailValidation.addressLineTwo && <p className="error">{detailValidation.addressLineTwo}</p>}
              </div>
            </div>

            <div className="col-12">
              <div className="form-group">
                <label htmlFor="cityName" className="d-block">City*</label>
                <input
                  type="text"
                  className={`form-control form-control-sm ${detailValidation.cityName ? "error" : ""}`}
                  id="cityName"
                  placeholder="City"
                  name="cityName"
                  value={invoiceDetail.cityName}
                  onChange={({ target: { value } }) => onValueChange("cityName", value)}
                />
                {detailValidation.cityName && <p className="error">{detailValidation.cityName}</p>}
              </div>
            </div>

            <div className="col-12">
              <div className="form-group">
                <label htmlFor="countryCode" className="d-block">Country*</label>
                <div className='selectbox'>
                  <select
                    className={`form-control form-control-sm ${detailValidation.countryCode ? "error" : ""}`}
                    name="countryCode"
                    value={invoiceDetail.countryCode}
                    onChange={
                      ({ target: { value } }) => {
                        const selectedCountry = countryList.find(country => country.countryCode === value);
                        const selectedCountryName = selectedCountry ? selectedCountry.countryName : '';
                        setCountryName(selectedCountryName); // Set the country name
                        onValueChange("countryCode", value);
                        setStateList([]);
                        setInvoiceDetail({ ...invoiceDetail, countryCode: value, stateCode: '' });
                        if (countryCodes.includes(value)) {
                          renderStateListOnCountryChange(value)
                        }
                      }
                    }
                  >
                    <option value="" >- Please Select -</option>

                    {countryList?.map((v, i) => (
                      <option key={v.countryId} value={v.countryCode}>{v.countryName}</option>
                    ))}
                  </select>
                </div>
                {detailValidation.countryCode && <p className="error">{detailValidation.countryCode}</p>}
              </div>
            </div>

            <div className="bs5 row">
              <div className="col-6">
                <div className="form-group">
                  <label htmlFor="stateCode" className="d-block">{stateList.length !== 0 ? 'State/Province*' : 'State/Province'}</label>
                  {(stateList.length !== 0) ?
                    <>
                      <div className='selectbox'>
                        <select
                          className={`form-control form-control-sm ${detailValidation.stateCode ? "error" : ""}`}
                          name="stateCode"
                          value={invoiceDetail.stateCode}
                          onChange={({ target: { value } }) => {
                            const selectedState = stateList.find(state => state.stateCode === value);
                            stateName = selectedState?.stateName || ""
                            setStateName(selectedState?.stateName || ""); // Set the state name
                            onValueChange("stateCode", value)
                          }}
                        >
                          <option value="">- Please Select -</option>
                          {stateList.map((v, i) => (
                            <option key={v.stateId} value={v.stateCode}>{v.stateName}</option>
                          ))}
                        </select>
                      </div>
                      {detailValidation.stateCode && <p className="error">{detailValidation.stateCode}</p>}
                    </>
                    :
                    <input
                      type="text"
                      className={`form-control form-control-sm ${""}`}
                      id="stateCode"
                      placeholder="State/Province"
                      name="stateCode"
                      value={invoiceDetail.stateCode}
                      onChange={({ target: { value } }) => onValueChange("stateCode", value)}
                    />
                  }
                </div>
              </div>

              <div className="col-6">
                <div className="form-group">
                  <label htmlFor="postalCode" className="d-block">Zip/Postal Code*</label>
                  <input
                    type="text"
                    className={`form-control form-control-sm ${detailValidation.postalCode ? "error" : ""}`}
                    id="postalCode"
                    placeholder="Zip/Postal Code"
                    name="postalCode"
                    value={invoiceDetail.postalCode}
                    onChange={({ target: { value } }) => onValueChange("postalCode", value)}
                  />
                  {detailValidation.postalCode && <p className="error">{detailValidation.postalCode}</p>}
                </div>
              </div>
            </div>
          </form>
        </div>
        <div className="modal-footer d-flex justify-content-center">
          <button type="button" disabled={loader} className="bs5 btn btn-secondary minw140" onClick={() => { SetStatus(false) }}>Cancel</button>
          <button type="button" disabled={loader} className="bs5 btn btn-primary minw140" onClick={onSaveUser}>{loader ? <i className="fa fa-spinner fa-spin "/> : "Submit"}</button>
        </div>
      </div>
    </div>
  );
};

export default ProfileAddressPopup;